import './menu_product.css';
import { serverEnv } from '../../env';
import { useEffect, useState } from "react";
import { useSingleProduct } from '../../context/SingleProductContext';

export const MenuProduct = ({product}) => {
    //HOOKS
    const { setSingleProduct } = useSingleProduct();

    //STATES
    const [imageUrl, setImageUrl] = useState("");

    //EFFECTS
    useEffect(() => {
        if (product.media.main_image !== "")
        {
            setImageUrl(serverEnv.backend + "/" + product.media.main_image);
        }
    }, [product]);

    return (
        <>
            <div className={imageUrl !== "" ? 'menu_product_item img' : 'menu_product_item'} onClick={() => setSingleProduct(product)}>
                <div className='content'>
                    <h2 className='product_item_title'>
                        {product.name}
                    </h2>
                    <p className='product_item_description'>
                        {product.description}
                    </p>
                    <span className='product_item_price'>
                        ${(product.pricing.price / 100).toFixed(2)}
                    </span>
                </div>
                <img src={imageUrl} alt="" />
            </div>
        </>
    );
}
